module.exports = __webpack_public_path__ + "img/5.43164ead.jpg";